import paths from "~/constants/paths";

export default defineNuxtRouteMiddleware((to) => {
  const { $features } = useNuxtApp();

  if (!$features?.bundles && to.path === paths.bundles) {
    return navigateTo(paths.home);
  }
});
